exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontlabel{\n    font-weight: normal\n}\n\n.odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}\n\ntable.bgborder, table.bgborder > thead > tr > th, table.bgborder > tbody > tr > td {\n    border: 1px solid #848a87;\n}\n\n.goal{\n    text-align: center;\n    padding-left: 182px;\n}\n\n.verticalAlign{\n    vertical-align: middle\n}\n\n.noData{\n    margin-top: 15px;\n    font-weight: bold;\n}\n\n.back{\n    padding-right: 20px;\n    padding-top: 16px;\n}\n\n.score_table{\n    width: 520px;\n    margin-left: 330px;\n    margin-top: 10px;\n}\n.billing-data {\n    margin-right: 15px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accountMetrics/list-account-metrics/list-account-metrics.component.css
// module id = ../../../../../src/app/accountMetrics/list-account-metrics/list-account-metrics.component.css
// module chunks = main